/**
 * Pure helpers for link/permission parity on customer routes.
 * See docs/AUTH_ROLES.md — UI permission gates (order-adjacent surfaces).
 */

export const isCustomerRouteUrl = (url: string): boolean => url.startsWith("/customers/");

export type CustomerLinkMessage = {
  display: string;
  url?: string;
};

/** Drop customer-route remediation URLs when the actor lacks customer view scope. */
export const stripCustomerRouteUrlsWhenOutOfScope = <T extends CustomerLinkMessage>(
  messages: readonly T[],
  customerViewInScope: boolean,
): T[] => {
  if (customerViewInScope) {
    return [...messages];
  }

  return messages.map(message => (message.url != undefined && isCustomerRouteUrl(message.url) ? { ...message, url: undefined } : message));
};
